import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';

export const pickDeep = (acc, value) => {
  const result = {};
  for (const key of Object.keys(value)) {
    if (isObject(value[key])) {
      result[key] = pickDeep(acc[key] ?? {}, value[key]);
    } else if (
      key === 'location' /* location is a special case */ ||
      !isNil(value[key])
    ) {
      result[key] = value[key];
    }
  }

  return {
    ...acc,
    ...result,
  };
};
